module.exports = __webpack_public_path__ + "static/media/Monstyr-Icon.5531c48e.png";